import axios from 'axios'
import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'lodash'
Vue.use(Vuex)

const isProd = process.env.VUE_APP_ENV === 'production'

import pagesJson from '../../json/pages.json'
import configJson from '../../json/config.json'
import navigationJson from '../../json/navigation.json'

// Store Modules
import property from './property.module'
import animations from './animations.module'
import sounds from './sounds.module'

export default new Vuex.Store({
  modules: {
    animations,
    property,
    sounds
  },

  state: {
    sessionId: Math.random().toString(36).substring(7),
    assetsPath: isProd ? '/assets/' : process.env.VUE_APP_ASSETS_HOST,
    version: process.env.VUE_APP_VERSION,

    config: isProd ? configJson : null,
    navigation: isProd ? navigationJson : null,
    pages: isProd ? pagesJson : null,

    isBottomBarVisible: false,
    triggerVideos: false,
    hideLiveHere: false,
    appScale: 1,

    language: { name: 'English', code: 'en', rtl: false },
    languages: [
      { name: 'English', code: 'en', rtl: false },
      { name: 'French', code: 'fr', rtl: false },
      { name: 'German', code: 'ge', rtl: false }
    ]
  },

  getters: {
    activeNavigation (state, getters) {
      let activeNavigationItem = null
      if (state.route.params.categoryId) {
        activeNavigationItem =  _.find(getters.navigation, category => {
          return category._id === state.route.params.categoryId
        })
      } else {
        getters.navigation.forEach(category => {
          if (state.route.path.includes(category.customRoute)) {
            activeNavigationItem = category
          }
        })
      }
      return activeNavigationItem && activeNavigationItem.children ? activeNavigationItem.children : null
    },

    activePage (state) {
      let activePage = null
      if (state.route.params.pageId) {
        activePage = _.find(state.pages, page => {
          return page._id === state.route.params.pageId
        })
      }
      return activePage
    },

    activeSubNavigation (state, getters) {
      let activeSubNavigation = []
      if (getters.activeNavigation && getters.activePage) {
        const activePageId = getters.activePage._id
        getters.activeNavigation.forEach(parentNavigationItem => {
          if (parentNavigationItem.pageId === activePageId) {
            activeSubNavigation = parentNavigationItem.children
          }
          if (parentNavigationItem.children) {
            parentNavigationItem.children.forEach(childNavigationItem => {
              if (childNavigationItem.pageId === activePageId) {
                activeSubNavigation = parentNavigationItem.children
              }
            })
          }
        })
      }
      return activeSubNavigation
    },

    navigation (state) {
      let navigation = JSON.parse(JSON.stringify(state.navigation))
      if (navigation && navigation.length) {
        navigation.forEach(navigationCategory => {
          navigationCategory.children = _.sortBy(navigationCategory.children, child => child.order)
        })
      }
      return navigation
    },

    language (state) {
      return state.language
    },

    languages (state) {
      return state.languages
    }
  },

  mutations: {
    SET_CONFIG (state, config) {
      state.config = config
    },

    SET_NAVIGATION (state, navigation) {
      state.navigation = navigation
    },

    SET_PAGES (state, pages) {
      state.pages = pages
    },

    SET_LANGUAGE (state, language) {
      state.language = language
    }
  },

  actions: {
    fetchData ({ commit }) {
      if (!isProd) {
        axios.get(process.env.VUE_APP_API_HOST + '/config').then(res => {
          const configItems = res.data.config.items
          let configObject = {}
          configItems.map(el => {
            configObject[el.key] = el.value
          })
          commit('SET_CONFIG', configObject)
        }).catch(err => {
          console.warn(err)
        })

        axios.get(process.env.VUE_APP_API_HOST + '/navigation').then(res => {
          commit('SET_NAVIGATION', res.data.categories)
        }).catch(err => {
          console.warn(err)
        })

        axios.get(process.env.VUE_APP_API_HOST + '/pages').then(res => {
          commit('SET_PAGES', res.data)
        }).catch(err => {
          console.warn(err)
        })

        axios.get(process.env.VUE_APP_API_HOST + '/living/living-options').then(res => {
          commit('property/SET_LIVING_OPTIONS', res.data)
        }).catch(err => {
          console.warn(err)
        })

        axios.get(process.env.VUE_APP_API_HOST + '/living/subsections').then(res => {
          commit('property/SET_SUBSECTIONS', res.data)
        }).catch(err => {
          console.warn(err)
        })    
        
        axios.get(process.env.VUE_APP_API_HOST + '/living/properties').then(res => {
          commit('property/SET_PROPERTIES', res.data)
        }).catch(err => {
          console.warn(err)
        })    
        
        axios.get(process.env.VUE_APP_API_HOST + '/living/property-models').then(res => {
          commit('property/SET_PROPERTY_MODELS', res.data)
        }).catch(err => {
          console.warn(err)
        })            
      }
    },

    storeVisitorInfo ({ getters, state }) {
      if (!isProd) {
        const pageHeading = getters.activePage.heading.en
        const sessionId = state.sessionId
        axios.post(process.env.VUE_APP_API_HOST + '/visitor', { page: pageHeading, sessionId: sessionId }).then(res => {

        }).catch(err => {
          console.warn(err)
        })
      }
    },

    toggleBottomBarVisibility ({ state }) {
      // TODO: dispatch a mutation that sets the bar as visible
      state.isBottomBarVisible = !state.isBottomBarVisible
    },
    
    triggerVideo ({ state }, videoWallTrigger) {
      if (state.triggerVideos && process.env.VUE_APP_VIDEOWALL_HOST && videoWallTrigger) {
        console.log(`GET ${process.env.VUE_APP_VIDEOWALL_HOST}/index.php?x=${videoWallTrigger}`)
        axios.get(`${process.env.VUE_APP_VIDEOWALL_HOST}/index.php?x=${videoWallTrigger}`)
          .then(function (response) {
            console.log(response)
          })
          .catch(function (error) {
            console.log(error);
          })
      }
    }
  }
})
